import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: `/controller/access-point`,

        async create({ name, username, password, domain, port, domainFailover, portFailover, controllerDefault, type, authorizationHash, controllerSiteId  }) {
            return Vue.http.post(this.userUrl({ path: `/` }), {
                name,
                username,
                password,
                domain,
                port,
                domainFailover,
                portFailover,
                controllerDefault,
                type,
                authorizationHash,
                controllerSiteId
            });
        },

        async edit({ controllerId, name, username, password, domain, port,  domainFailover, portFailover, controllerDefault, type, authorizationHash, controllerSiteId }) {
            return Vue.http.put(this.userUrl({ path: `/${controllerId}` }), {
                name,
                username,
                password,
                domain,
                port,
                domainFailover,
                portFailover,
                controllerDefault,
                type,
                authorizationHash,
                controllerSiteId
            });
        },

        async test({ id, name, username, password, domain, port, domainFailover, portFailover, type, controllerSiteId}) {
            return Vue.http.post(this.userUrl({ path: `/test` }), {
                id,
                name,
                username,
                password,
                domain,
                port,
                domainFailover,
                portFailover,
                type,
                controllerSiteId
            });
        },

        async testFailover({ id, name, username, password, domain, port, domainFailover, portFailover, type}) {
            return Vue.http.post(this.userUrl({ path: `/test-failover` }), {
                id,
                name,
                username,
                password,
                domain,
                port,
                domainFailover,
                portFailover,
                type,
            });
        },

        async updateNetworks({ controllerId, networks}) {
            return Vue.http.put(this.userUrl({ path: `/${controllerId}/networks` }), networks)
        },

        async list() {
            return Vue.http.get(this.userUrl({ path: "/" }));
        },

        async types() {
            return Vue.http.get(this.userUrl({ path: "/types" }));
        },

        async get({ controllerId }) {
            return Vue.http.get(this.userUrl({ path: `/${controllerId}` }));
        },

        async delete({ controllerId }) {
            return Vue.http.delete(this.userUrl({ path: `/${controllerId}` }));
        },
    },
    base
);
